import { createContext, useState, useEffect, useContext } from "react";

import {
  getAccount,
  getProfile,
  getUserPremiumStatus,
} from "../../api/account/requests";
import { getFreeTrialEligibility } from "../../api/subscription/requests";
import { mergeAll } from "ramda";
import { useToken } from "./token";
import { useQuery } from "@tanstack/react-query";

const UserContext = createContext();

// todo: rewrite this to use react-query
const UserProvider = ({ children }) => {
  const [user, setUser] = useState();
  const token = useToken();

  const { data } = useQuery({
    queryKey: ["user", token.data?.account_id],
    queryFn: () => Promise.all([getProfile(), getAccount()]),
    enabled: !!token.data?.account_id,
  })

  useEffect(() => {
    setUser(data ? mergeAll(data) : undefined);
  }, [data, setUser])

  useEffect(() => {
    if (!user?.externalId) return;

    getFreeTrialEligibility(user.externalId).then((result) =>
      setUser(user => ({ ...user, ...result }))
    );
  }, [user?.externalId]);

  useEffect(() => {
    if (!user?.externalId) return;

    getUserPremiumStatus(user.externalId)
      .then((result) => setUser(user => ({ ...user, ...result })))
      .catch((err) => console.error(err));
  }, [user?.externalId]);

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};

const useUserContext = () => useContext(UserContext)

export { UserContext, UserProvider, useUserContext };
